import { useSelector } from 'react-redux'
import { selectHttpErrors } from '../features/errors/selectors'
import authActions from '../features/auth/actions'
import { useTeloDispatch } from '../store'
import { useEffect } from 'react'

const tokenErrorMessages = [
	'Error during token verify',
	'Token expired',
	'Not authenticated',
]

export const useTokenError = () => {
	const httpErrors = useSelector(selectHttpErrors)
	const dispatch = useTeloDispatch()
	const isTokenError = httpErrors.find(({ message }) =>
		tokenErrorMessages.includes(message),
	)

	useEffect(() => {
		if (isTokenError) {
			dispatch(authActions.logoutAction())
		}
	}, [isTokenError, dispatch])

	return isTokenError
}
